'use client';

import { createContext, useContext, useMemo } from 'react';

export interface SmartLinkOption {
  label: string;
  value: string;
}

export interface TiptapSmartLinkConfig {
  resolve?: (identifier: string, context: { url: string; newTab?: boolean }) => void;
  getOptions?: () => Promise<SmartLinkOption[]>;
}

const SmartLinkContext = createContext<TiptapSmartLinkConfig | null>(null);

export function SmartLinkProvider({
  config,
  children,
}: {
  config?: TiptapSmartLinkConfig | null;
  children: React.ReactNode;
}) {
  const value = useMemo(() => config ?? null, [config]);

  return <SmartLinkContext.Provider value={value}>{children}</SmartLinkContext.Provider>;
}

export function useSmartLink(): TiptapSmartLinkConfig | null {
  return useContext(SmartLinkContext);
}
